export const stakingAddress = "0x78d96cdac89BBF1Db31daDca0Af192A09DF2E0b0";
export const tokenAddress = "0x0a94EA47dE185D6376Db4Cad70123ec8de4f2841";
